/**
 * Formato visual pesos colombianos: $20.000.000
 * (separador de miles con punto, sin decimales).
 */
export function formatPesosCop(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    const digits = String(Math.trunc(Math.abs(value)));
    return `$${digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  }
  const raw = String(value).trim();
  // Solo tratar como decimales tipo API ("25000000.00"), no miles "20.000"
  if (/^-?\d+[.,]\d{1,2}$/.test(raw)) {
    return formatPesosCop(Number(raw.replace(',', '.')));
  }
  const digits = raw.replace(/\D/g, '');
  if (!digits) {
    return '';
  }
  return `$${digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
}

/** Extrae el entero desde un valor formateado ($20.000.000 / 20,000,000 / crudo). */
export function parsePesosCop(value: unknown): number {
  const digits = String(value ?? '').replace(/\D/g, '');
  return digits ? Number(digits) : 0;
}
